import { useEditorCollab } from './useEditorCollab';

// Monte le client de collaboration temps réel.
// No-op tant que le back n'expose pas EditorCollabChannel (abonnement jamais confirmé).
const CollabClient = () => {
  useEditorCollab();
  return null;
};

export default CollabClient;
